var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMainBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0h-13A1.5 1.5 0 000 1.5v2c0 .275.225.5.5.5H1v8.5A1.5 1.5 0 002.5 14h11a1.5 1.5 0 001.5-1.5V4h.5c.275 0 .5-.225.5-.5v-2A1.5 1.5 0 0014.5 0zM14 12.5c0 .275-.225.5-.5.5h-11a.501.501 0 01-.5-.5V4h12v8.5zM15 3H1V1.5c0-.275.225-.5.5-.5h13c.275 0 .5.225.5.5V3zM6.375 7h3.25A.376.376 0 0010 6.625v-.25A.376.376 0 009.625 6h-3.25A.376.376 0 006 6.375v.25c0 .206.169.375.375.375z",
    fill: "#3A50F3"
  })));
}

export default __webpack_public_path__ + "./fonts/main-box.bb881bc5817e5f59e42fe133151638c4.svg";
export { SvgMainBox as ReactComponent };